<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { Background } from "./Background.js";
	import { type OlProps, OlSize } from "./OlProps.js";

	const {
		items,
		size = OlSize.Small,
		background = Background.Light,
	}: { items: OlProps[]; size?: OlSize; background?: Background } = $props();
	const onlyTitle = items.every((item) => item.desc === "" || item.desc === undefined);
</script>

{#each items as { title, customNumber, desc }, index (index)}
	<div
		class={[
			"flex flex-row-reverse lg:flex-row justify-between lg:justify-start gap-6 lg:gap-12",
			onlyTitle && "items-center",
		]}
	>
		<div
			class={[
				"font-loos-wide font-bold text-fstgreen h-14 aspect-square rounded-full flex justify-center items-center transition-colors",
				background === Background.Onyx ? "bg-fstgrey-900" : "bg-white",
			]}
		>
			{customNumber ?? index + 1}
		</div>
		<div class="pt-1">
			{#if title}
				<h3 class={["text-2md tracking-[0.01em] mb-2", background === Background.Onyx ? "text-white" : "text-fstonyx"]}>
					<Formatted text={title} />
				</h3>
			{/if}
			<p
				class={[
					"mb-0 max-w-[30.625rem] text-fstgrey-200",
					size === OlSize.Small && "text-sm",
					size === OlSize.Medium && "text-base",
					size === OlSize.Large && background !== Background.Onyx && "text-lg font-loos-wide text-fstonyx",
				]}
			>
				<Formatted text={desc} />
			</p>
		</div>
	</div>
{/each}
